var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Lead, H4 } from '.';
var DataBoxContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 24px 24px 60px;\n"], ["\n\tpadding: 24px 24px 60px;\n"])));
var Title = styled(H4)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-bottom: 18px;\n"], ["\n\tmargin-bottom: 18px;\n"])));
var Body = styled(Lead)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-bottom: 16px;\n"], ["\n\tmargin-bottom: 16px;\n"])));
export var DataBox = function (_a) {
    var title = _a.title, children = _a.children, button = _a.button, className = _a.className;
    return (React.createElement(DataBoxContainer, { className: className },
        React.createElement(Title, null, title),
        React.createElement(Body, null,
            " ",
            children,
            " "),
        button));
};
var templateObject_1, templateObject_2, templateObject_3;
